import React, { Fragment, useEffect } from 'react'
import { connect } from 'react-redux';
import {
  Col, Row, CardBody, Card, Collapse, CardText, Alert,
} from 'reactstrap'
import moment from 'moment';
import { useParams } from 'react-router-dom';
import Section from '../../components/Section';
import { IOrderState } from '../../store/order/types';
import {
  getOrderData,
  toggleOrderLoading,
  resetOrderState,
  assignActivityIsOpenFields,
  toggleActivity,
  getOrderActivity, toggleActivityContentLoading, setActivityError,
} from '../../store/order/action';
import TextInput from '../../components/Inputs/TextInput';
import ContactCard from '../../components/Widgets/ContactCard';
import { IAccountState } from '../../store/account/types';
import { Gravatar } from '../../components/Gravatar/Gravatar';
import SimpleLoader from '../../components/SimpleLoader';
import ComplexTable from '../../components/Table/ComplexTable';
import { AppDispatch } from '../../configureStore';
import { getTicketActivity } from '../../store/ticket/actions'
import DeleteIconButton from '../../components/Buttons/DeleteIconButton'

type TParams = { id: string };
type TOwnProps = {
  order: IOrderState;
  account: IAccountState;
  dispatch: AppDispatch;
};
type TProps = TOwnProps;
const getActivityType = (type, email) => {

  switch (type) {
    case 'Email':
      if (email && email.match(/(syntura.io|hso.uk.com|goscomb.net)/)) {

        return { cssClass: 'accord--email-inbound', label: 'Inbound email' };

      }
      return { cssClass: 'accord--email-outbound', label: 'Outbound email' };
    case 'Phone Call':
      return { cssClass: 'accord--phone', label: 'Phone' };
    case 'Case Resolution':
      return { cssClass: 'accord--resolved', label: 'Resolved' };
    default:
      return { cssClass: '', label: '' };
  }

};
const Order: React.FC<TProps> = (props) => {

  const {
    loading, data, loadingActivities,
  } = props.order;

  const params = useParams();

  useEffect(() => {

    props.dispatch(resetOrderState());
    props.dispatch(toggleOrderLoading());
    props.dispatch(getOrderData(params.id, { include: 'products,projectManager,activities' })).then(() => {
      props.dispatch(toggleOrderLoading());
      props.dispatch(assignActivityIsOpenFields());
    });

  }, []);
  const createMarkup = (markup) => ({ __html: markup });
  const toggleActivityStateHandler = (id) => {
    const activity = data.activities.find((act) => id === act.id);
    if (activity && !activity.isOpen && !activity.content) {
      props.dispatch(toggleActivityContentLoading(id));
      props.dispatch(getOrderActivity(id, activity.id)).then(() => props.dispatch(toggleActivityContentLoading(id)));
    }
    props.dispatch(toggleActivity(id));
  };

  const formatDateTime = (date) => {
    return moment(date).format('DD/MM/YYYY HH:mm:ss');
  };

  const columns = [
    {
      Header: 'Product Number',
      accessor: 'productNumber',
    },
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Status',
      accessor: 'status',
    },
    {
      Header: 'Date Created',
      accessor: 'createdOn',
      Cell: (props) => (props.value ? moment(props.value).format('DD/MM/YYYY') : <></>),
    },
  ];
  return (
    <div className="animated fadeIn mb-5">
      <SimpleLoader loading={loading}>
        <Row>
          <Col>
            <Section title={`Order ${data.orderNumber}`}>
              <Row>
                <Col md={4} className="d-flex">
                  <div className="bg-white shadow-sm pt-4 pl-4 pb-4 d-flex flex-column w-100" style={{ borderRadius: '10px' }}>
                    <TextInput label="Order Number" id="orderNumber" value={data.orderNumber} readOnly />
                    <TextInput label="Name" id="name" value={data.name} readOnly />
                    <TextInput label="Status" id="status" value={data.status} readOnly />
                    <TextInput label="Created" id="createdAt" value={data.createdOn ? moment(data.createdOn).format('DD/MM/YYYY') : ''} readOnly />
                    <TextInput label="Project Mgr" id="createdAt" value={`${data.projectManager.firstName} ${data.projectManager.lastName}`} readOnly />
                  </div>
                </Col>
                <Col md={8} className="d-flex">
                  <div className="d-flex flex-column w-100 h-100">
                    <Card style={{ borderRadius: '10px' }} className="px-2 pt-3 mb-0 h-100">
                      <ComplexTable
                        columns={columns}
                        data={data.products}
                        defaultPageSize={5}
                      />
                    </Card>
                  </div>
                </Col>
              </Row>
            </Section>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={12} xl={8}>
            <Section title="Email Activity">
              <SimpleLoader loading={loadingActivities}>
                <div className="card p-5 accord" style={{ borderRadius: '10px' }}>
                  {data.activities && data.activities.map((activity) => (
                      <Fragment key={activity.id}>
                        <div
                            className={` accord__bar p-3 mb-2 ${getActivityType(activity.type, activity.emailAddresses.from).cssClass}`}
                        >
                          <Row
                              className="mb-2"
                              onClick={() => toggleActivityStateHandler(activity.id)}
                          >
                            <Col className="d-flex align-items-center" md="2">
                            <span
                                className="text-upperticket"
                            >
                              {' '}
                              {getActivityType(activity.type, activity.emailAddresses.from).label}
                              {' '}

                            </span>
                            </Col>
                            <Col className="d-flex align-items-center text-dark" md="2">
                            <span>
                              {formatDateTime(activity.modifiedOn)}
                            </span>
                            </Col>
                            <Col className="d-flex align-items-center text-dark" md="2">
                              <span>{activity.createdBy}</span>
                            </Col>
                            <Col className="d-flex align-items-center text-dark" md="4">
                              <span className="text-wrap">{activity.subject}</span>
                            </Col>
                            <Col className="d-flex align-items-center text-light" md="2">
                              {activity.isOpen && (<i className="fa fa-minus text-light ml-auto" />)}
                              {!activity.isOpen && (<i className="fa fa-plus text-light  ml-auto" />)}
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <Collapse isOpen={activity.isOpen}>
                                <Card style={{ boxShadow: 'none', border: 'none' }}>
                                  <CardBody>
                                    <SimpleLoader loading={activity.contentLoading}>
                                      <CardText style={{ whiteSpace: 'pre-line', marginBottom: '4px' }}>
                                        <strong>From:</strong> {activity.emailAddresses && activity.emailAddresses.from ? activity.emailAddresses.from : (activity.createdBy ? activity.createdBy : '')}
                                      </CardText>
                                      <CardText style={{ whiteSpace: 'pre-line', marginBottom: '4px' }}>
                                        <strong>Sent:</strong> {formatDateTime(activity.createdOn)}
                                      </CardText>
                                      <CardText style={{ whiteSpace: 'pre-line', marginBottom: '4px' }}>
                                        <strong>To:</strong> {activity.emailAddresses?.to || ''}
                                      </CardText>
                                      {activity.emailAddresses.cc && (
                                          <CardText style={{ whiteSpace: 'pre-line', marginBottom: '4px' }}>
                                            <strong>Cc:</strong> {activity.emailAddresses.cc}
                                          </CardText>
                                      )}
                                      <CardText style={{ whiteSpace: 'pre-line', marginBottom: '4px' }}>
                                        <strong>Subject:</strong> <span style={{ fontWeight: 600 }}>{activity.subject}</span>
                                      </CardText>

                                      {activity.error && (
                                          <Alert color={'danger'} className={'mt-4'}>activity.error'</Alert>
                                      )}
                                      {activity.content && (
                                          <Card className="mt-4" style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'auto', width: '100%' }}>
                                            <CardBody style={{ minHeight: 100 }}>
                                              <div dangerouslySetInnerHTML={{ __html: activity.content }} />
                                            </CardBody>
                                          </Card>
                                      )}
                                    </SimpleLoader>
                                  </CardBody>
                                </Card>
                              </Collapse>
                            </Col>
                          </Row>
                        </div>
                      </Fragment>
                  ))}
                </div>
              </SimpleLoader>
            </Section>
          </Col>
          <Col md={8} xl={4}>
            <Section title="Order Project Manager">
              <ContactCard
                firstName={data.projectManager.firstName}
                lastName={data.projectManager.lastName}
                email={data.projectManager.email}
                phone={data.projectManager.telephone}
                jobTitle="Project Manager"
                dropShadow
                emailSubject={data.orderNumber}
              />
            </Section>
          </Col>
        </Row>
      </SimpleLoader>
    </div>
  );

};
function mapStateToProps({ order, user, account }) {

  return {
    user,
    order,
    account,
  };

}
export default connect(mapStateToProps)(Order);
